module.exports = __webpack_public_path__ + "static/img/4g-gas.42946581.svg";